// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartNewOrderHeader {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px;
  background: #f4f8fd;
  border-bottom: 1px solid #dbeafe;
  /* border-radius: 4px; */
  /* margin: 6px 8px 4px; */
}

.cartNewOrderLabel {
  font-size: 0.75rem;
  font-weight: 700;
  color: #1447e6;
  flex: 1;
}

.cartNewOrderTime {
  font-size: 0.7rem;
  font-weight: 500;
  color: #1447e6;
}

.rightContainer {
  display: flex;
  flex-direction: column !important;
  justify-content: space-between;
  border-radius: 0;
  height: 100%;
  overflow: hidden;
  gap: 5px;
  background: #f5f8ff;
}

.clear-cart-button-container {
  display: flex;
  justify-content: flex-end;
}

.clear-cart-button {
  color: #2a71ff;
  font-weight: 700;
  font-size: 0.75rem !important;
  background-color: #fff;
  border: 0.2px solid #bcbcbc;
  border-radius: 3px;
  padding: 10px;
  cursor: pointer;
}

.addCustomericons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  background-color: #fff;
  border-radius: 7px;
  padding: 0 1rem;
  margin-bottom: 1rem !important;
  min-height: 3rem;
}

.dark .addCustomericons {
  background-color: #353a50;
}

.switch-wrapper-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.number-container {
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: var(--blue);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
}

.editicon {
  padding: 5px !important;
  border-radius: 50%;
  width: 35px !important;
  height: 35px !important;
  background-color: #0562fb !important;
  color: #fff !important;
}

.editicon-green {
  padding: 5px !important;
  border-radius: 50%;
  width: 35px !important;
  height: 35px !important;
  background-color: green !important;
  color: #fff !important;
}

.editicon-green:hover {
  background-color: rgb(43, 255, 43) !important;
}

.cart-table-product-details {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

.dark .editicon {
  background-color: #353a50;
  color: white;
}

.light .editicon {
  background-color: white;
  color: black;
}

.number {
  font-weight: 700 !important;
}

.number-text {
  font-weight: 500;
  font-size: 1rem;
}

.dark .number {
  color: white;
}

.emptyCartContainer {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.no-free-emptyCartContainer {
  width: 100%;
  height: 100% !important;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  align-content: center;
  color: white;
  padding: 3%;
  overflow-y: auto !important;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.light .no-free-emptyCartContainer {
  background-color: white;
}

.dark .no-free-emptyCartContainer {
  background-color: #353a50 !important;
}

.free-item-margin {
  margin-top: 10px;
  height: 20% !important;
  width: 100%;
  align-items: center;
  flex-direction: column;
  background-color: #353a50;
  border-radius: 10px;
  align-content: center;
  color: white;
  padding: 3%;
  overflow-y: auto !important;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.light .free-item-margin {
  background-color: white;
  color: rgb(41, 84, 165);
}

.dark .free-item-margin {
  background-color: #353a50;
  color: white;
}

.light .emptyCartContainer:focus {
  outline: none;
}

.dark .emptyCartContainer:focus {
  outline: none;
}

.Barcode-scanner-img {
  max-width: 20rem;
  width: 100%;
}

.customer-details-header {
  display: flex;
  justify-content: space-between;
  background-color: #2a71ff;
  color: #fff;
  padding: 7px;
  margin: 5px 0px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 15px;
}

.customer-details-left-side {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.customer-details-left-side :nth-child(2) {
  font-size: 12px;
  cursor: pointer;
}

.customer-details-right-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.customer-details-right-side :nth-child(2) {
  font-size: 12px;
}

.empty-cart-img {
  width: 190px;
  height: 192px;
}

.totalCartValueContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0.5px solid #000;
  padding: 0px 7px;
}

.totalCartValueHeader :nth-child(1) {
  font-size: 0.875rem;
  font-weight: 600;
}

.totalCartValueHeader :nth-child(2) {
  font-size: 0.5rem;
  font-weight: 600;
}

.totalCartPrice {
  font-size: 26px;
  font-weight: 700;
}

.emptyCartContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.emptyCartContainer::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #f5f5f5;
}

.emptyCartContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

.dark .emptyCartContainer {
  color: white;
}

.light .emptyCartContainer {
  color: black;
}

.cartItemConatiner {
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  width: 100%;
  justify-content: space-around !important;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.offer-cartItemConatiner {
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around !important;
  padding: 1rem 0.5rem !important;
  border-radius: 7px;
  margin-bottom: 0.5rem;
  height: 10px !important;
}

.selectedCartItem {
  background-color: #e3e8ff !important;
  color: #0562fb !important;
  border: solid 1px #0562fb !important;
}

.deleteCartIcons {
  font-size: 2rem !important;
  width: 10% !important;
  min-width: 1.5rem !important;
  max-width: 1.5rem !important;
  margin-left: 0 !important;
  cursor: pointer !important;
  margin-right: 3% !important;
  border-radius: 50% !important;
  text-align: center !important;
}

.cartElementName {
  font-size: 0.9rem;
  text-transform: capitalize !important;
  margin-right: 2% !important;
  width: 75% !important;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}

.increaseDecreseItemQuantityContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: fit-content;
  background-color: #353a50;
  border: none;
}

.decreaseCartItemQuantity {
  border-radius: 5px !important;
  font-size: 1.2rem !important;
  padding: 0px 8px !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 23px !important;
  background-color: #fff !important;
  color: #000 !important;
  font-weight: bold;
  border: solid 1px #0562fb;
  background-color: #e3e8ff !important;
  color: #0562fb !important;
}

.light .decreaseCartItemQuantity:focus {
  outline: none;
  background-color: #0562fb !important;
  color: #fff !important;
}

.dark .decreaseCartItemQuantity:focus {
  outline: none;
  background-color: #0562fb !important;
  color: #fff !important;
}

.cartRowItem {
  width: 100%;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0px 1% !important;
  border: none;
  text-align: center;
  background-color: transparent;
  letter-spacing: 0.12em;
}

.dark .cartRowItem {
  color: #fff !important;
  font-weight: 900 !important;
}

.light .cartRowItem:focus {
  background-color: #dbdee9 !important;
}

.dark .cartRowItem:focus {
  background-color: #dbdee9 !important;
}

.dark .cartRowItem::placeholder {
  color: #fff !important;
}

.dark .cartRowItem:focus {
  background-color: #353a50 !important;
}

.increseCartItemQuantity {
  border-radius: 5px !important;
  font-size: 1.2rem !important;
  padding: 0px 6px !important;
  margin-right: 1% !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 23px !important;
  background-color: #fff !important;
  color: #000 !important;
  font-weight: bold;
  border: solid 1px #0562fb;
  background-color: #e3e8ff !important;
  color: #0562fb !important;
}

.light .increseCartItemQuantity:focus {
  outline: none;
  background-color: #0562fb !important;
  color: #fff !important;
}

.dark .increseCartItemQuantity:focus {
  outline: none;
  background-color: #0562fb !important;
  color: #fff !important;
}

.eachCartItemPrice {
  font-size: 0.813rem !important;
  font-weight: 700;
  display: flex !important;
  justify-content: center !important;
}

.trash-can-icon-border {
  background: #fef2f2;
  padding: 4px;
  border: 1px solid #ffe2e2;
  border-radius: 50%;
}

.noItemCart {
  display: flex !important;
  width: 100% !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
  border-radius: 12px;
  margin-top: 10px;
}

.light .noItemCart {
  background-color: white;
}

.dark .noItemCart {
  background-color: #353a50 !important;
}

.emptyCartText {
  /* font-size: 1rem;
  text-align: center;
  font-weight: 600;
  color: var(--surface-g3); */
  align-self: stretch;
  color: var(--Surface-G5, #333);
  text-align: center;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: var(--20, 20px);
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 26px */
}

.emptyCartSubText {
  font-size: 1rem;
  font-weight: 600;
  color: var(--surface-g3);
}

/* ── Empty cart state ── */
.empty-cart-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 32px 24px;
  border: 1.5px dashed #bfdbfe;
  border-radius: 16px;
  background: #f8faff;
  width: 100%;
  max-width: 280px;
}

.empty-cart-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.empty-cart-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.empty-cart-sub {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

.paymentDetails {
  height: fit-content;
  background-color: #353a50;
  border-radius: 10px;
  color: white;
  margin-top: 1rem;
  padding: 1rem !important;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.dark .paymentDetails {
  background-color: #353a50;
  color: white;
}

.light .paymentDetails {
  background-color: white;
  color: black;
}

.payment-cart-remove-main-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-cart-remove-box {
  font-weight: bold;
  cursor: pointer;
  color: red;
  font-size: 1.2rem;
}

.items-text-length-wrapper {
  font-size: 1rem;
  font-weight: 600;
  color: #0562fb;
}

.cart-items-display {
  display: flex;
  align-items: center;
  gap: 15px;
}

.hover-text-show {
  font-size: 1rem;
  color: red;
  font-weight: 600;
  text-transform: capitalize;
}

.totalpaymentBox {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
}

.checkoutBtn {
  width: 100%;
  background-color: #0562fb !important;
  border-radius: 4px;
  color: white;
  margin-top: 1vh;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: #0562fb 0px 3px 5px -2px !important;
  letter-spacing: 1px;
  min-height: 2.8rem;
}

.checkoutBtn:hover {
  box-shadow: none !important;
}

.checkoutBtn:focus {
  outline: none;
  background-color: #0562fb;
  opacity: 0.5;
}

.checkoutBtn-I {
  width: 100%;
  height: 5vh;
  background-color: #0562fb !important;
  opacity: 0.5;
  border-radius: 10px;
  color: white;
  margin-top: 2vh;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: #0562fb 0px 3px 5px -2px !important;
  letter-spacing: 1px;
  min-height: 2.8rem;
}

.checkoutBtn-I:hover {
  box-shadow: none !important;
}

.checkoutBtn-I:focus {
  outline: none;
  background-color: #0562fb;
  opacity: 0.5;
}

.form-edit-wrapper {
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-modal-wrapper-box {
  width: 200px;
  height: 200px;
  border: 4px solid red;
  margin: 0 auto;
  text-align: center;
}

.dark .delete-modal-wrapper-box {
  background-color: #353a50;
  color: #fff;
}

.checkoutBtn-I:disabled {
  cursor: not-allowed !important;
}

.available-offer-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0px 40px;
  padding: 0px 20px 20px 20px !important;
}

.local-offer-icon {
  color: greenyellow !important;
  margin-right: 10px;
}

.red-local-offer-icon {
  color: red !important;
  margin-right: 10px;
}

.offer-avail-card {
  margin-top: 10px !important;
}

.light .offer-avail-card {
  background-color: white;
  color: 353A50;
}

.dark .offer-avail-card {
  background-color: #353a50;
  color: white;
}

.delete-text-theme {
  color: white !important;
}

.dark .delete-text-theme {
  color: black !important;
}

/* Redesigning Cart */

.deliveryOptionsContainer {
  margin-top: 10px;
}

.modal-bg-customer {
  position: absolute;
  background-color: #00000023;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 90px);
  height: 100vh;
}

.customerDetailsContainer {
  display: flex;
  width: 100%;
  padding: var(--16, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--16, 16px);

  background-color: var(--surface-white);
  border-radius: 8px;
  flex-shrink: 0;
}

.customerDetailsContainerSecondHeader {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.cartHoldAndDelete {
  display: flex;
  gap: 8px;
}

.cartRightIcons {
  display: flex;
  gap: 8px;
}

.customerDatailsOuterSalesMode {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--surface-g0);
  overflow: visible;
  height: 32px;
}

.customerDatailsOuterSalesMode.dark {
  background-color: var(--dark-background);
}

.customerDetailsContainerSecond {
  padding-bottom: 10px;
  border-bottom: 1px solid var(--surface-g1);
  flex-shrink: 0;
}

.cartDetailsCartId {
  font-size: 1rem;
  font-weight: 700;
  margin-top: 8px;
}

.cartDetailsItemNo {
  color: var(--surface-g4);
  font-size: 0.813rem;
  font-weight: 400;
  margin-bottom: 8px;
  padding-top: 4px;
}

.cartNotesSection {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.cartNotesSection p {
  color: var(--blue-b0);
  font-size: 0.813rem;
  margin-bottom: 4px;
}

.customer-notes {
  margin-top: 3px;
}

.cartBottomSectionInner {
  display: flex;
  justify-content: space-between;
  font-size: 0.813rem;
  font-weight: 600;
  padding-bottom: 3px;
  margin-bottom: 1px;
}

.cartCouponSection {
  background-color: var(--surface-g0);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  justify-content: space-between;
}

.cartTotalSection {
  background-color: var(--surface-g0);
  border-radius: 8px;
  padding: 8px;
  margin-top: 10px;
}

.paymentMethodContainer {
  padding: 8px;
  margin-top: 5px;
  font-size: 1rem;
  font-weight: 700;
}

.paymentMethodInnerContainer {
  display: flex;
  gap: 15px;
  margin-top: 8px;
}

.paymentProcessContainer {
  padding: 8px 0;
  flex-shrink: 0;
}

.proceManuallyText {
  font-size: 1rem;
  font-weight: 700;
}

.cartChangeInput {
  border: 1px solid var(--surface-g2);
  border-radius: 8px;
  padding: 12px 12px;
  width: 100%;
  margin-top: 2px;
  font-size: 1rem;
  font-weight: 700;
}

.cartAmountText {
  font-size: 1rem;
  font-weight: 700;
  margin-top: 5px;
}

.paymentProcessNoticeBoard {
  border: 1px solid var(--surface-g2);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 4px 64px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.paymentProcssNoticeBoardGrayText {
  font-size: 1rem;
  font-weight: 600;
  color: var(--surface-g4);
}

.paymentProcssNoticeBoardGreenText {
  font-size: 1rem;
  font-weight: 600;
  color: #219647;
}

.paymentProcssNoticeBoardRedText {
  font-size: 1rem;
  font-weight: 600;
  color: #e90000;
}

.cartBottomSectionWrapper {
  flex-shrink: 0;
  width: 100%;
  background-color: #fbfcfd;
  padding: 10px;
  border-radius: 8px;
}

.cartGrossAndActionRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px 6px 10px;
  background-color: var(--surface-white);
  /* border-top: 1px solid var(--surface-g1, #f0f0f0); */
  flex-shrink: 0;
  margin-left: auto;
}

.cartGrossTotalInfo {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.cartNoteIconBtn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff7e6;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d97706;
  flex-shrink: 0;
  transition: background 0.15s;
}

.cartNoteIconBtn:hover {
  background: #fef3c7;
}

.cartGrossTotalLabel {
  font-size: 0.688rem;
  font-weight: 600;
  color: var(--surface-g4, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 1px 0;
}

.cartGrossAmountRow {
  display: flex;
  align-items: center;
  gap: 4px;
}

.cartGrossAmount {
  font-size: 18px;
  font-weight: 800;
  color: var(--surface-black);
  margin: 0;
  line-height: 1.1;
}

.cartGrossActionButtons {
  display: flex;
  gap: 6px;
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
}

.cartBottomSectionWrapper.bottom {
  margin-top: auto;
}

.cartProductsList {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  background-color: #fbfcfd;
  /* padding: 10px; */
  border-radius: 8px;
  /* margin-top: 10px; */
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.cartProductsList::-webkit-scrollbar {
  width: 6px;
}

.cartProductsList::-webkit-scrollbar-track {
  background: transparent;
}

.cartProductsList::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.5); /* slate-400 with opacity */
  border-radius: 20px;
}

.cartProductsList::-webkit-scrollbar-thumb:hover {
  background-color: rgba(148, 163, 184, 0.8);
}

/* Floating Scroll Arrow Button */
.cartScrollArrowButton {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  background-color: #2463eb;
  color: white;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(36, 99, 235, 0.4);
  cursor: pointer;
  animation: jump 1.6s infinite ease-in-out;
  transition: all 0.2s ease;
}

.cartScrollArrowButton:hover {
  background-color: #1d4ed8;
  transform: translateX(-50%) scale(1.05);
  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.5);
}

.cartScrollArrowButton:active {
  transform: translateX(-50%) scale(0.95);
}

@keyframes jump {
  0%,
  100% {
    transform: translate(-50%, 0);
  }
  50% {
    transform: translate(-50%, -8px);
  }
}

.offer-btn-cart {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.fineDineInButtonContainer {
  display: flex;
  gap: 8px;
  width: 100%;
}

.tableNumberContainer {
  font-weight: 700;
  color: var(--blue-b0);
  font-size: 1rem;
  margin-bottom: 8px;
}

.dineInCheckOutButton {
  display: flex;
  gap: 8px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.dineInCheckOutButton > * {
  min-width: 0 !important;
  flex-shrink: 1;
}

.dineInCheckOutButton button {
  min-width: 0 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tableNumberContainerIcon {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.table-layout-display {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  line-height: 1.2;
}

.cart-table-layout-display {
  color: #90a1b9;
  font-size: 12px;
}

.tableActionContainerOnCart {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.tableActionbuttonOnCart {
  display: flex;
  gap: 8px;
}

.cartUpperDetailsContainer {
  background-color: var(--surface-white);
  padding: 10px;
  border-radius: 8px;
  flex-shrink: 0;
  margin-bottom: 4px;
}

.qsrSaleModeContainer {
  display: flex;
  justify-content: center;
  padding: 8px;
  flex-shrink: 0;
}

.qsrSaleModeButtons {
  display: flex;
  gap: 4px;
  align-items: center;
  background: #f1f5f9;
  /* border: 1px solid #d3dae6; */
  border-radius: 16px;
  padding: 4px;
  width: 100%;
  justify-content: space-between;
}

.qsrSaleModeBtn {
  border: none;
  background: transparent;
  color: #62748e;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  border-radius: 16px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.16s ease;
  white-space: nowrap;
  flex: 1;
}

.qsrSaleModeBtn:hover {
  background: rgba(17, 24, 39, 0.06);
}

.qsrSaleModeBtn.active {
  background: #fff;
  color: #2463eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22);
}

.cartTotalArrowButton {
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}

.cartDetailsSection {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.35s ease;
}

.cartDetailsSection.expanded {
  max-height: 300px;
  opacity: 1;
}

.kotContainer {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--surface-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 0;
}

.kotText {
  display: flex;
  gap: 5px;
  background-color: #eff6ff;
  color: var(--blue-b1);
  font-size: 11px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #bedbff;
}

.kotTextInner {
  display: flex;
  gap: 1px;
}

.kotTextLabel {
  font-size: 11px;
  font-weight: 600;
  color: var(--blue-b1);
  margin: 0;
  line-height: 1.3;
}

.kotTextAmount {
  font-size: 11px;
  font-weight: 700;
  color: #1d4ed8;
  margin: 0;
  line-height: 1.3;
}

.cartTableKotsHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.cartTableName {
  font-weight: 700;
  color: var(--blue-b0);
  font-size: 1rem;
}

/* ── Delivery / Takeaway order-type card in cart header ── */
.cart-order-type-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 14px;
  width: 100%;
}

.cart-order-type-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cart-order-type-label {
  font-size: 9px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.cart-order-type-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a56db;
  line-height: 1.2;
}

.cart-order-type-sub {
  font-size: 11px;
  color: #6b7280;
  margin-top: 1px;
}

.cart-order-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #16a34a;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 20px;
  padding: 4px 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.cart-order-type-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #16a34a;
  flex-shrink: 0;
}

.cartTableInfoContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--surface-white);
  padding: 8px 10px;
  border-radius: 8px;
  flex-shrink: 0;
  /* margin-bottom: 4px;
  margin-top: 4px; */
}

.cartItemDivider {
  border: none;
  border-top: 1px dashed #d1d5db;
  margin: 0 4px;
}

.cartCouponSectionContainer {
  background-color: var(--surface-white);
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.cartAndSidebarContainer {
  height: 100%;
  display: flex;
  gap: 8px;
  overflow: hidden;
  flex: 1;
  padding: 10px 10px 10px 0px;
  background: #ffff;
}

.cartAndSidebarContainer > div:first-child {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cartRightSidebarContainer {
  flex-shrink: 0;
  width: 80px;
  /* Height is dynamically set inline in Cart.js to accommodate table info in Fine Dine */
  padding-bottom: 8px;
  box-sizing: border-box;
  position: relative;
}

.bottomCouponSectionWrapper {
  margin-bottom: 8px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.toggle-switch {
  width: 42px;
  height: 20px;
  background-color: #ccc;
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.switch {
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: all 0.3s ease;
}

.toggle-switch.on .switch {
  left: 24px;
}

.toggle-switch.on {
  background-color: #4caf50;
}

.listViewActionButton {
  display: flex;
  gap: 6px;
  align-items: center;
}

.list-view-toggle-container {
  display: flex;
  gap: 4px;
  align-items: center;
  font-weight: 600;
  font-size: 0.813rem;
}

.aggCartProductsLoaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
}

.aggCartProductsContainer {
  /* max-height: 100%; */
  overflow-y: auto;
}

.aggCartProductsContainer::-webkit-scrollbar {
  width: 6px;
}

.aggCartProductsContainer::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.aggCartProductsContainer::-webkit-scrollbar-track {
  background-color: transparent;
}

.aggCartProductsWrapper {
  margin-bottom: 12px;
}

.aggCartViewDivider {
  margin-bottom: 12px;
  margin-top: 8px;
  color: var(--surface-g1);
  opacity: 50%;
}

.notesInputWithLoader {
  position: relative;
  width: 100%;
}

.loaderInsideNotesInput {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.complimentoryCratWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.complimentaryModeActionButton {
  width: 100%;
  display: flex;
  gap: 4px;
}

.mobileFloatingOptsContainer {
  position: fixed;
  bottom: 160px;
  right: 12px;
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
}

.mobileOptionsBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  z-index: 999;
}

.mobileOptionsBackdrop.show {
  opacity: 1;
  pointer-events: auto;
}

.mobileOptionsSheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60vh;
  background: #fff;
  border-radius: 16px 16px 0 0;
  transform: translateY(100%);
  transition: transform 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.mobileOptionsSheet.open {
  transform: translateY(0);
}

.sheetHeader {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px 0px 16px;
}

.sheetContent {
  overflow-y: auto;
  padding: 8px;
}

.cartBottonOtterWrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.checkoutButton {
  width: 100%;
  flex-shrink: 0;
}

.cartInformationText {
  margin-bottom: 8px;
  flex-shrink: 0;
}

.addDeliveryChargeWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.total-text-box {
  font-size: 0.875rem;
  font-weight: 600;
}

.number-icon {
  margin-left: 4px;
}

.sub-total-main-wrapper-conatiner-key {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.isExplodingDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  pointer-events: none;
}

.cartBottomSectionContainer {
  flex-shrink: 0;
}

.cartGrossActionBarSpacer {
  height: 35px;
  flex-shrink: 0;
}

/* ── Proceed mode layout (DeliveryPage / TakeawayPage / DineinPage) ── */

/* Inner column wrapper: form on top, totals below — stretches to fill the row */
.cart-proceed-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 8px;
}

/* Form takes full width */
.cart-proceed-content > div {
  width: 100%;
}

/* Totals panel: auto height */
.cart-proceed-content .cartBottonOtterWrapper {
  height: auto;
  flex-shrink: 0;
}

/* No margin-top: auto needed in column layout */
.cart-proceed-content .cartBottomSectionWrapper.bottom {
  margin-top: 0;
}

/* Totals grid: 2 columns side-by-side */
.cart-proceed-content .cartTotalSection {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
  margin-top: 0;
}

.cart-proceed-content .cartBottomSectionInner {
  background: var(--surface-white);
  border-radius: 6px;
  padding: 6px 8px;
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
}

/* Grand Total spans full width */
.cart-proceed-content .cartBottomSectionInner:last-child {
  grid-column: 1 / -1;
  font-size: 0.875rem;
  font-weight: 700;
  background: var(--surface-g0);
}

/**************** Responsive *****************/
@media (max-width: 768px) {
  .cartAndSidebarContainer {
    height: 100%;
  }

  .cartProductsList {
    position: relative;
  }

  .cartBottomSectionWrapper {
    margin-bottom: 30px;
  }
}

/* ════════════════════════════════════════════════════
   DARK THEME — Cart
   ════════════════════════════════════════════════════ */
.dark .rightContainer {
  background: #0f172a;
}
.dark .cartNewOrderHeader {
  background: #1e293b;
  border-bottom-color: #334155;
}
.dark .cartNewOrderLabel,
.dark .cartNewOrderTime {
  color: #60a5fa;
}
.dark .cartAndSidebarContainer {
  background: #0f172a;
}
.dark .clear-cart-button {
  background-color: #1e293b;
  border-color: #475569;
  color: #60a5fa;
}
.dark .customerDetailsContainer {
  background-color: #1e293b;
}
.dark .customerDetailsContainerSecond {
  border-bottom-color: #334155;
}
.dark .cartDetailsCartId {
  color: #f1f5f9;
}
.dark .cartDetailsItemNo {
  color: #94a3b8;
}
.dark .cartTableInfoContainer {
  background-color: #1e293b;
}
.dark .cartCouponSectionContainer {
  background-color: #1e293b;
}
.dark .kotContainer {
  background-color: #0f172a;
}
.dark .kotText {
  background-color: rgba(42, 113, 255, 0.15);
  border-color: rgba(42, 113, 255, 0.3);
}
.dark .cartItemDivider {
  border-top-color: #334155;
}
/* Empty cart state */
.dark .empty-cart-state {
  background: #1e293b;
  border-color: #334155;
}
.dark .empty-cart-icon-wrap {
  background: rgba(59, 130, 246, 0.15);
}
.dark .empty-cart-title {
  color: #f1f5f9;
}
.dark .empty-cart-sub {
  color: #94a3b8;
}
.dark .emptyCartText {
  color: #94a3b8;
}
.dark .emptyCartSubText {
  color: #64748b;
}
/* Cart order-type card */
.dark .cart-order-type-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .cart-order-type-label {
  color: #64748b;
}
.dark .cart-order-type-title {
  color: #60a5fa;
}
.dark .cart-order-type-sub {
  color: #94a3b8;
}
/* Cart gross total row */
.dark .cart-gross-total-label-new {
  color: #94a3b8;
}
.dark .cart-gross-amount-new {
  color: #f1f5f9;
}
/* Cart action buttons */
.dark .cart-btn-outline {
  background-color: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
  box-shadow: none;
}
.dark .cart-btn-outline:hover:not(:disabled) {
  background-color: #334155;
  border-color: #475569;
}
/* Mobile sheet */
.dark .mobileOptionsSheet {
  background: #1e293b;
}
/* ── Order Notes Modal ── */
@keyframes onmSlideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.onm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1400;
  background: rgba(0, 0, 0, 0.35);
}

.onm-modal {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 80vw;
  background: #fff;
  border-radius: 0;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.18);
  animation: onmSlideIn 0.22s ease;
}

.onm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.onm-title {
  font-size: 0.9rem;
  font-weight: 800;
  color: #d97706;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.onm-optional-badge {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 20px;
  padding: 3px 12px;
}

.onm-subtitle {
  font-size: 0.82rem;
  color: #374151;
  margin: -6px 0 0 0;
  line-height: 1.5;
}

.onm-textarea-wrap {
  position: relative;
}

.onm-textarea {
  width: 100%;
  border: 1.5px solid #93c5fd;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 0.85rem;
  color: #111827;
  resize: none;
  outline: none;
  font-family: inherit;
  line-height: 1.5;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.onm-textarea:focus {
  border-color: #3b82f6;
}

.onm-textarea::placeholder {
  color: #9ca3af;
}

.onm-loader {
  position: absolute;
  top: 10px;
  right: 10px;
}

.onm-char-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 14px;
  margin-top: -4px;
}

.onm-char-hint {
  font-size: 0.78rem;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70%;
}

.onm-char-count {
  font-size: 0.72rem;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

.onm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
}

.onm-btn {
  height: 38px;
  padding: 0 22px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s;
}

.onm-btn-clear {
  background: #fff;
  color: #374151;
  border: 1.5px solid #d1d5db;
}

.onm-btn-clear:hover {
  background: #f9fafb;
}

.onm-btn-done {
  background: #3b82f6;
  color: #fff;
  border: none;
}

.onm-btn-done:hover:not(:disabled) {
  background: #2563eb;
}

.onm-btn-done:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Order notes modal dark */
.dark .onm-modal {
  background: #1e293b;
}
.dark .onm-title {
  color: #fbbf24;
}
.dark .onm-optional-badge {
  background: #334155;
  color: #94a3b8;
}
.dark .onm-subtitle {
  color: #94a3b8;
}
.dark .onm-textarea {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .onm-textarea:focus {
  border-color: #3b82f6;
}
.dark .onm-char-row {
  background: #0f172a;
  border-color: #334155;
}
.dark .onm-char-hint {
  color: #64748b;
}
.dark .onm-char-count {
  color: #64748b;
}
.dark .onm-btn-clear {
  background: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}
.dark .onm-btn-clear:hover {
  background: #334155;
}

@media (min-width: 1024px) and (max-width: 1100px) {
  .cartGrossAndActionRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    padding: 7px 8px 6px;
    margin-left: auto;
  }

  .cartNoteIconBtn {
    width: 34px;
    height: 34px;
    border-radius: 9px;
  }

  .cartGrossTotalLabel {
    font-size: 0.62rem;
    letter-spacing: 0.04em;
  }

  .cartGrossAmount {
    font-size: 17px;
  }

  .cartAndSidebarContainer {
    gap: 6px;
    padding: 8px 8px 8px 0;
  }

  .cartRightSidebarContainer {
    width: 64px;
  }

  .qsrSaleModeContainer {
    padding: 8px 6px;
  }

  .qsrSaleModeButtons {
    gap: 3px;
  }
}

/* Custom normal buttons styling for cartGrossAndActionRow, matching reference Tailwind design */
.cart-kitchen-note-btn {
  display: flex;
  height: 48px;
  width: 48px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid rgba(253, 230, 138, 0.6); /* border-amber-200/60 */
  background-color: rgba(255, 251, 235, 0.5); /* bg-amber-50/50 */
  color: #b45309; /* text-amber-700 */
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.08); /* shadow-[0_2px_8px_rgba(245,158,11,0.08)] */
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  outline: none;
}

.cart-kitchen-note-btn:hover:not(:disabled) {
  border-color: #fcd34d; /* hover:border-amber-300 */
  background-color: #fef3c7; /* hover:bg-amber-100 */
}

.cart-kitchen-note-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cart-kitchen-note-btn svg {
  width: 20px;
  height: 20px;
  stroke-width: 2.5;
}

.cart-gross-total-column {
  display: flex;
  flex-direction: column;
}

.cart-gross-total-label-new {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #64748b; /* text-slate-500 */
  margin: 0;
}

.cart-gross-amount-new {
  font-size: 1.25rem; /* text-xl */
  font-weight: 800; /* font-extrabold */
  color: #0f172a; /* text-slate-900 */
  line-height: 1; /* leading-none */
  margin-top: 2px; /* mt-0.5 */
  margin-bottom: 0;
}

.cart-btn-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  outline: none;
  border: 1px solid #cbd5e1; /* border-slate-300 */
  background-color: #ffffff; /* bg-white */
  padding: 8px 20px;
  height: 48px;
  border-radius: 28px;
  font-size: 0.875rem; /* text-sm */
  font-weight: 600; /* font-semibold */
  color: #334155; /* text-slate-700 */
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06); /* shadow-[0_8px_20px_rgba(15,23,42,0.06)] */
  cursor: pointer;
  box-sizing: border-box;
}

.cart-btn-outline:hover:not(:disabled) {
  border-color: #94a3b8; /* hover:border-slate-400 */
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

.cart-btn-outline:disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.cart-btn-outline svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.cart-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  outline: none;
  border: 1px solid #2a71ff;
  height: 48px;
  border-radius: 28px;
  background-color: #2a71ff; /* bg-[#2A71FF] */
  padding: 8px 32px;
  font-size: 0.875rem; /* text-sm */
  font-weight: 700; /* font-bold */
  color: #ffffff; /* text-white */
  box-shadow: 0 12px 28px rgba(42, 113, 255, 0.2); /* shadow-[0_12px_28px_rgba(42,113,255,0.2)] */
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  box-sizing: border-box;
}

.cart-btn-primary:hover:not(:disabled) {
  background-color: #155eef; /* hover:bg-[#155EEF] */
  border-color: #155eef;
  box-shadow: 0 16px 36px rgba(42, 113, 255, 0.25); /* hover:shadow-[0_16px_36px_rgba(42,113,255,0.25)] */
  transform: translateY(-1px); /* hover:-translate-y-[1px] */
}

.cart-btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.cart-btn-primary:disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.cart-btn-primary svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* ── Cart type strip (B2B / B2C pill) ── */
.cart-type-strip {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 10px;
  background: transparent;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  flex-shrink: 0;
}
.dark .cart-type-strip {
  border-bottom-color: rgba(255,255,255,0.06);
}

.cart-type-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  white-space: nowrap;
  flex-shrink: 0;
}
.cart-type-pill--b2b {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}
.cart-type-pill--b2c {
  background: #eff6ff;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}
.dark .cart-type-pill--b2b {
  background: rgba(217,119,6,0.15);
  color: #fcd34d;
  border-color: rgba(217,119,6,0.3);
}
.dark .cart-type-pill--b2c {
  background: rgba(59,130,246,0.12);
  color: #93c5fd;
  border-color: rgba(59,130,246,0.22);
}

.cart-type-label {
  font-size: 11px;
  font-weight: 500;
  color: #92400e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}
.dark .cart-type-label { color: #fbbf24; }

/* ── B2B Sales Order badge strip (legacy — kept for non-item sections) ── */
.b2b-order-badge-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #fffbeb, #fef3c7);
  border-bottom: 1px solid #fde68a;
  flex-shrink: 0;
}
.b2b-order-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 9999px;
  background: #d97706;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.b2b-order-badge svg { flex-shrink: 0; }
.b2b-order-partner {
  font-size: 12px;
  font-weight: 500;
  color: #92400e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dark .b2b-order-badge-strip {
  background: linear-gradient(135deg, #1c1107, #27180a);
  border-bottom-color: #78350f;
}
.dark .b2b-order-badge { background: #b45309; }
.dark .b2b-order-partner { color: #fbbf24; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/Cart.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;;uCAEqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B;;uCAEqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B;;uCAEqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;uCAEqC;EACrC,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;;uCAEqC;EACrC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;;6BAG2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB;;uCAEqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;EAEpB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sCAAsC;EACtC,sDAAsD;EACtD,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C,EAAE,2BAA2B;EACvE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;;IAEE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd;oBACkB;AACpB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,OAAO;EACP,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uFAAuF;EACvF,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,yEAAyE;;AAEzE,gFAAgF;AAChF;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;yDAEyD;AACzD;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,yBAAyB;AACzB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;AACA,4BAA4B;AAC5B;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,gGAAgG;AAChG;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C,EAAE,wBAAwB;EACpE,0CAA0C,EAAE,mBAAmB;EAC/D,cAAc,EAAE,mBAAmB;EACnC,8CAA8C,EAAE,6CAA6C;EAC7F,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,kBAAkB,EAAE,YAAY;EAChC,gBAAgB,EAAE,mBAAmB;EACrC,cAAc,EAAE,mBAAmB;EACnC,cAAc,EAAE,iBAAiB;EACjC,eAAe,EAAE,WAAW;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB,EAAE,aAAa;EACxC,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,6CAA6C,EAAE,4CAA4C;EAC3F,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB,EAAE,iBAAiB;EAC5C,iBAAiB;EACjB,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,eAAe;EAC/B,+CAA+C,EAAE,8CAA8C;EAC/F,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,qBAAqB;EACrB,gDAAgD,EAAE,qDAAqD;EACvG,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,yBAAyB,cAAc,EAAE;;AAEzC,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;EACrD,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA,uBAAuB,cAAc,EAAE;AACvC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,qDAAqD;EACrD,4BAA4B;AAC9B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,2BAA2B,cAAc,EAAE","sourcesContent":[".cartNewOrderHeader {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px;\n  background: #f4f8fd;\n  border-bottom: 1px solid #dbeafe;\n  /* border-radius: 4px; */\n  /* margin: 6px 8px 4px; */\n}\n\n.cartNewOrderLabel {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #1447e6;\n  flex: 1;\n}\n\n.cartNewOrderTime {\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: #1447e6;\n}\n\n.rightContainer {\n  display: flex;\n  flex-direction: column !important;\n  justify-content: space-between;\n  border-radius: 0;\n  height: 100%;\n  overflow: hidden;\n  gap: 5px;\n  background: #f5f8ff;\n}\n\n.clear-cart-button-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.clear-cart-button {\n  color: #2a71ff;\n  font-weight: 700;\n  font-size: 0.75rem !important;\n  background-color: #fff;\n  border: 0.2px solid #bcbcbc;\n  border-radius: 3px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.addCustomericons {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n  background-color: #fff;\n  border-radius: 7px;\n  padding: 0 1rem;\n  margin-bottom: 1rem !important;\n  min-height: 3rem;\n}\n\n.dark .addCustomericons {\n  background-color: #353a50;\n}\n\n.switch-wrapper-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.number-container {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  background-color: var(--blue);\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.editicon {\n  padding: 5px !important;\n  border-radius: 50%;\n  width: 35px !important;\n  height: 35px !important;\n  background-color: #0562fb !important;\n  color: #fff !important;\n}\n\n.editicon-green {\n  padding: 5px !important;\n  border-radius: 50%;\n  width: 35px !important;\n  height: 35px !important;\n  background-color: green !important;\n  color: #fff !important;\n}\n\n.editicon-green:hover {\n  background-color: rgb(43, 255, 43) !important;\n}\n\n.cart-table-product-details {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: center;\n}\n\n.dark .editicon {\n  background-color: #353a50;\n  color: white;\n}\n\n.light .editicon {\n  background-color: white;\n  color: black;\n}\n\n.number {\n  font-weight: 700 !important;\n}\n\n.number-text {\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.dark .number {\n  color: white;\n}\n\n.emptyCartContainer {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  color: white;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.no-free-emptyCartContainer {\n  width: 100%;\n  height: 100% !important;\n  align-items: center;\n  flex-direction: column;\n  border-radius: 10px;\n  align-content: center;\n  color: white;\n  padding: 3%;\n  overflow-y: auto !important;\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n}\n\n.light .no-free-emptyCartContainer {\n  background-color: white;\n}\n\n.dark .no-free-emptyCartContainer {\n  background-color: #353a50 !important;\n}\n\n.free-item-margin {\n  margin-top: 10px;\n  height: 20% !important;\n  width: 100%;\n  align-items: center;\n  flex-direction: column;\n  background-color: #353a50;\n  border-radius: 10px;\n  align-content: center;\n  color: white;\n  padding: 3%;\n  overflow-y: auto !important;\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n}\n\n.light .free-item-margin {\n  background-color: white;\n  color: rgb(41, 84, 165);\n}\n\n.dark .free-item-margin {\n  background-color: #353a50;\n  color: white;\n}\n\n.light .emptyCartContainer:focus {\n  outline: none;\n}\n\n.dark .emptyCartContainer:focus {\n  outline: none;\n}\n\n.Barcode-scanner-img {\n  max-width: 20rem;\n  width: 100%;\n}\n\n.customer-details-header {\n  display: flex;\n  justify-content: space-between;\n  background-color: #2a71ff;\n  color: #fff;\n  padding: 7px;\n  margin: 5px 0px;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.customer-details-left-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.customer-details-left-side :nth-child(2) {\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.customer-details-right-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.customer-details-right-side :nth-child(2) {\n  font-size: 12px;\n}\n\n.empty-cart-img {\n  width: 190px;\n  height: 192px;\n}\n\n.totalCartValueContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 0.5px solid #000;\n  padding: 0px 7px;\n}\n\n.totalCartValueHeader :nth-child(1) {\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.totalCartValueHeader :nth-child(2) {\n  font-size: 0.5rem;\n  font-weight: 600;\n}\n\n.totalCartPrice {\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.emptyCartContainer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.emptyCartContainer::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n  background-color: #f5f5f5;\n}\n\n.emptyCartContainer::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\n.dark .emptyCartContainer {\n  color: white;\n}\n\n.light .emptyCartContainer {\n  color: black;\n}\n\n.cartItemConatiner {\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n  width: 100%;\n  justify-content: space-around !important;\n  border-radius: 4px;\n  margin-bottom: 0.5rem;\n}\n\n.offer-cartItemConatiner {\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around !important;\n  padding: 1rem 0.5rem !important;\n  border-radius: 7px;\n  margin-bottom: 0.5rem;\n  height: 10px !important;\n}\n\n.selectedCartItem {\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n  border: solid 1px #0562fb !important;\n}\n\n.deleteCartIcons {\n  font-size: 2rem !important;\n  width: 10% !important;\n  min-width: 1.5rem !important;\n  max-width: 1.5rem !important;\n  margin-left: 0 !important;\n  cursor: pointer !important;\n  margin-right: 3% !important;\n  border-radius: 50% !important;\n  text-align: center !important;\n}\n\n.cartElementName {\n  font-size: 0.9rem;\n  text-transform: capitalize !important;\n  margin-right: 2% !important;\n  width: 75% !important;\n  white-space: normal;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n.increaseDecreseItemQuantityContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  width: fit-content;\n  background-color: #353a50;\n  border: none;\n}\n\n.decreaseCartItemQuantity {\n  border-radius: 5px !important;\n  font-size: 1.2rem !important;\n  padding: 0px 8px !important;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 23px !important;\n  background-color: #fff !important;\n  color: #000 !important;\n  font-weight: bold;\n  border: solid 1px #0562fb;\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n}\n\n.light .decreaseCartItemQuantity:focus {\n  outline: none;\n  background-color: #0562fb !important;\n  color: #fff !important;\n}\n\n.dark .decreaseCartItemQuantity:focus {\n  outline: none;\n  background-color: #0562fb !important;\n  color: #fff !important;\n}\n\n.cartRowItem {\n  width: 100%;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin: 0px 1% !important;\n  border: none;\n  text-align: center;\n  background-color: transparent;\n  letter-spacing: 0.12em;\n}\n\n.dark .cartRowItem {\n  color: #fff !important;\n  font-weight: 900 !important;\n}\n\n.light .cartRowItem:focus {\n  background-color: #dbdee9 !important;\n}\n\n.dark .cartRowItem:focus {\n  background-color: #dbdee9 !important;\n}\n\n.dark .cartRowItem::placeholder {\n  color: #fff !important;\n}\n\n.dark .cartRowItem:focus {\n  background-color: #353a50 !important;\n}\n\n.increseCartItemQuantity {\n  border-radius: 5px !important;\n  font-size: 1.2rem !important;\n  padding: 0px 6px !important;\n  margin-right: 1% !important;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 23px !important;\n  background-color: #fff !important;\n  color: #000 !important;\n  font-weight: bold;\n  border: solid 1px #0562fb;\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n}\n\n.light .increseCartItemQuantity:focus {\n  outline: none;\n  background-color: #0562fb !important;\n  color: #fff !important;\n}\n\n.dark .increseCartItemQuantity:focus {\n  outline: none;\n  background-color: #0562fb !important;\n  color: #fff !important;\n}\n\n.eachCartItemPrice {\n  font-size: 0.813rem !important;\n  font-weight: 700;\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.trash-can-icon-border {\n  background: #fef2f2;\n  padding: 4px;\n  border: 1px solid #ffe2e2;\n  border-radius: 50%;\n}\n\n.noItemCart {\n  display: flex !important;\n  width: 100% !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center !important;\n  height: 100%;\n  border-radius: 12px;\n  margin-top: 10px;\n}\n\n.light .noItemCart {\n  background-color: white;\n}\n\n.dark .noItemCart {\n  background-color: #353a50 !important;\n}\n\n.emptyCartText {\n  /* font-size: 1rem;\n  text-align: center;\n  font-weight: 600;\n  color: var(--surface-g3); */\n  align-self: stretch;\n  color: var(--Surface-G5, #333);\n  text-align: center;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: var(--20, 20px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: 130%; /* 26px */\n}\n\n.emptyCartSubText {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--surface-g3);\n}\n\n/* ── Empty cart state ── */\n.empty-cart-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 32px 24px;\n  border: 1.5px dashed #bfdbfe;\n  border-radius: 16px;\n  background: #f8faff;\n  width: 100%;\n  max-width: 280px;\n}\n\n.empty-cart-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  background: #eff6ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.empty-cart-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n\n.empty-cart-sub {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.paymentDetails {\n  height: fit-content;\n  background-color: #353a50;\n  border-radius: 10px;\n  color: white;\n  margin-top: 1rem;\n  padding: 1rem !important;\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n}\n\n.dark .paymentDetails {\n  background-color: #353a50;\n  color: white;\n}\n\n.light .paymentDetails {\n  background-color: white;\n  color: black;\n}\n\n.payment-cart-remove-main-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.payment-cart-remove-box {\n  font-weight: bold;\n  cursor: pointer;\n  color: red;\n  font-size: 1.2rem;\n}\n\n.items-text-length-wrapper {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #0562fb;\n}\n\n.cart-items-display {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.hover-text-show {\n  font-size: 1rem;\n  color: red;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.totalpaymentBox {\n  display: flex;\n  justify-content: space-between;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.checkoutBtn {\n  width: 100%;\n  background-color: #0562fb !important;\n  border-radius: 4px;\n  color: white;\n  margin-top: 1vh;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: #0562fb 0px 3px 5px -2px !important;\n  letter-spacing: 1px;\n  min-height: 2.8rem;\n}\n\n.checkoutBtn:hover {\n  box-shadow: none !important;\n}\n\n.checkoutBtn:focus {\n  outline: none;\n  background-color: #0562fb;\n  opacity: 0.5;\n}\n\n.checkoutBtn-I {\n  width: 100%;\n  height: 5vh;\n  background-color: #0562fb !important;\n  opacity: 0.5;\n  border-radius: 10px;\n  color: white;\n  margin-top: 2vh;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: #0562fb 0px 3px 5px -2px !important;\n  letter-spacing: 1px;\n  min-height: 2.8rem;\n}\n\n.checkoutBtn-I:hover {\n  box-shadow: none !important;\n}\n\n.checkoutBtn-I:focus {\n  outline: none;\n  background-color: #0562fb;\n  opacity: 0.5;\n}\n\n.form-edit-wrapper {\n  width: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-modal-wrapper-box {\n  width: 200px;\n  height: 200px;\n  border: 4px solid red;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.dark .delete-modal-wrapper-box {\n  background-color: #353a50;\n  color: #fff;\n}\n\n.checkoutBtn-I:disabled {\n  cursor: not-allowed !important;\n}\n\n.available-offer-box {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 0px 40px;\n  padding: 0px 20px 20px 20px !important;\n}\n\n.local-offer-icon {\n  color: greenyellow !important;\n  margin-right: 10px;\n}\n\n.red-local-offer-icon {\n  color: red !important;\n  margin-right: 10px;\n}\n\n.offer-avail-card {\n  margin-top: 10px !important;\n}\n\n.light .offer-avail-card {\n  background-color: white;\n  color: 353A50;\n}\n\n.dark .offer-avail-card {\n  background-color: #353a50;\n  color: white;\n}\n\n.delete-text-theme {\n  color: white !important;\n}\n\n.dark .delete-text-theme {\n  color: black !important;\n}\n\n/* Redesigning Cart */\n\n.deliveryOptionsContainer {\n  margin-top: 10px;\n}\n\n.modal-bg-customer {\n  position: absolute;\n  background-color: #00000023;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 90px);\n  height: 100vh;\n}\n\n.customerDetailsContainer {\n  display: flex;\n  width: 100%;\n  padding: var(--16, 16px);\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--16, 16px);\n\n  background-color: var(--surface-white);\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.customerDetailsContainerSecondHeader {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cartHoldAndDelete {\n  display: flex;\n  gap: 8px;\n}\n\n.cartRightIcons {\n  display: flex;\n  gap: 8px;\n}\n\n.customerDatailsOuterSalesMode {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--surface-g0);\n  overflow: visible;\n  height: 32px;\n}\n\n.customerDatailsOuterSalesMode.dark {\n  background-color: var(--dark-background);\n}\n\n.customerDetailsContainerSecond {\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--surface-g1);\n  flex-shrink: 0;\n}\n\n.cartDetailsCartId {\n  font-size: 1rem;\n  font-weight: 700;\n  margin-top: 8px;\n}\n\n.cartDetailsItemNo {\n  color: var(--surface-g4);\n  font-size: 0.813rem;\n  font-weight: 400;\n  margin-bottom: 8px;\n  padding-top: 4px;\n}\n\n.cartNotesSection {\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.cartNotesSection p {\n  color: var(--blue-b0);\n  font-size: 0.813rem;\n  margin-bottom: 4px;\n}\n\n.customer-notes {\n  margin-top: 3px;\n}\n\n.cartBottomSectionInner {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.813rem;\n  font-weight: 600;\n  padding-bottom: 3px;\n  margin-bottom: 1px;\n}\n\n.cartCouponSection {\n  background-color: var(--surface-g0);\n  border-radius: 8px;\n  padding: 8px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.cartTotalSection {\n  background-color: var(--surface-g0);\n  border-radius: 8px;\n  padding: 8px;\n  margin-top: 10px;\n}\n\n.paymentMethodContainer {\n  padding: 8px;\n  margin-top: 5px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.paymentMethodInnerContainer {\n  display: flex;\n  gap: 15px;\n  margin-top: 8px;\n}\n\n.paymentProcessContainer {\n  padding: 8px 0;\n  flex-shrink: 0;\n}\n\n.proceManuallyText {\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.cartChangeInput {\n  border: 1px solid var(--surface-g2);\n  border-radius: 8px;\n  padding: 12px 12px;\n  width: 100%;\n  margin-top: 2px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.cartAmountText {\n  font-size: 1rem;\n  font-weight: 700;\n  margin-top: 5px;\n}\n\n.paymentProcessNoticeBoard {\n  border: 1px solid var(--surface-g2);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  padding: 4px 64px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.paymentProcssNoticeBoardGrayText {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--surface-g4);\n}\n\n.paymentProcssNoticeBoardGreenText {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #219647;\n}\n\n.paymentProcssNoticeBoardRedText {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #e90000;\n}\n\n.cartBottomSectionWrapper {\n  flex-shrink: 0;\n  width: 100%;\n  background-color: #fbfcfd;\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.cartGrossAndActionRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 10px 6px 10px;\n  background-color: var(--surface-white);\n  /* border-top: 1px solid var(--surface-g1, #f0f0f0); */\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.cartGrossTotalInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.cartNoteIconBtn {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #fff7e6;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d97706;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n\n.cartNoteIconBtn:hover {\n  background: #fef3c7;\n}\n\n.cartGrossTotalLabel {\n  font-size: 0.688rem;\n  font-weight: 600;\n  color: var(--surface-g4, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0 0 1px 0;\n}\n\n.cartGrossAmountRow {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.cartGrossAmount {\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--surface-black);\n  margin: 0;\n  line-height: 1.1;\n}\n\n.cartGrossActionButtons {\n  display: flex;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.cartBottomSectionWrapper.bottom {\n  margin-top: auto;\n}\n\n.cartProductsList {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  background-color: #fbfcfd;\n  /* padding: 10px; */\n  border-radius: 8px;\n  /* margin-top: 10px; */\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.cartProductsList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.cartProductsList::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.cartProductsList::-webkit-scrollbar-thumb {\n  background-color: rgba(148, 163, 184, 0.5); /* slate-400 with opacity */\n  border-radius: 20px;\n}\n\n.cartProductsList::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(148, 163, 184, 0.8);\n}\n\n/* Floating Scroll Arrow Button */\n.cartScrollArrowButton {\n  position: absolute;\n  bottom: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  background-color: #2463eb;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 10px rgba(36, 99, 235, 0.4);\n  cursor: pointer;\n  animation: jump 1.6s infinite ease-in-out;\n  transition: all 0.2s ease;\n}\n\n.cartScrollArrowButton:hover {\n  background-color: #1d4ed8;\n  transform: translateX(-50%) scale(1.05);\n  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.5);\n}\n\n.cartScrollArrowButton:active {\n  transform: translateX(-50%) scale(0.95);\n}\n\n@keyframes jump {\n  0%,\n  100% {\n    transform: translate(-50%, 0);\n  }\n  50% {\n    transform: translate(-50%, -8px);\n  }\n}\n\n.offer-btn-cart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.fineDineInButtonContainer {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.tableNumberContainer {\n  font-weight: 700;\n  color: var(--blue-b0);\n  font-size: 1rem;\n  margin-bottom: 8px;\n}\n\n.dineInCheckOutButton {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.dineInCheckOutButton > * {\n  min-width: 0 !important;\n  flex-shrink: 1;\n}\n\n.dineInCheckOutButton button {\n  min-width: 0 !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tableNumberContainerIcon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.table-layout-display {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  line-height: 1.2;\n}\n\n.cart-table-layout-display {\n  color: #90a1b9;\n  font-size: 12px;\n}\n\n.tableActionContainerOnCart {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.tableActionbuttonOnCart {\n  display: flex;\n  gap: 8px;\n}\n\n.cartUpperDetailsContainer {\n  background-color: var(--surface-white);\n  padding: 10px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  margin-bottom: 4px;\n}\n\n.qsrSaleModeContainer {\n  display: flex;\n  justify-content: center;\n  padding: 8px;\n  flex-shrink: 0;\n}\n\n.qsrSaleModeButtons {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  background: #f1f5f9;\n  /* border: 1px solid #d3dae6; */\n  border-radius: 16px;\n  padding: 4px;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.qsrSaleModeBtn {\n  border: none;\n  background: transparent;\n  color: #62748e;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1;\n  border-radius: 16px;\n  padding: 8px 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.16s ease;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.qsrSaleModeBtn:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.qsrSaleModeBtn.active {\n  background: #fff;\n  color: #2463eb;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22);\n}\n\n.cartTotalArrowButton {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  cursor: pointer;\n}\n\n.cartDetailsSection {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: all 0.35s ease;\n}\n\n.cartDetailsSection.expanded {\n  max-height: 300px;\n  opacity: 1;\n}\n\n.kotContainer {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: var(--surface-white);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  padding: 8px 0;\n}\n\n.kotText {\n  display: flex;\n  gap: 5px;\n  background-color: #eff6ff;\n  color: var(--blue-b1);\n  font-size: 11px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid #bedbff;\n}\n\n.kotTextInner {\n  display: flex;\n  gap: 1px;\n}\n\n.kotTextLabel {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--blue-b1);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.kotTextAmount {\n  font-size: 11px;\n  font-weight: 700;\n  color: #1d4ed8;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.cartTableKotsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.cartTableName {\n  font-weight: 700;\n  color: var(--blue-b0);\n  font-size: 1rem;\n}\n\n/* ── Delivery / Takeaway order-type card in cart header ── */\n.cart-order-type-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 10px 14px;\n  width: 100%;\n}\n\n.cart-order-type-left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cart-order-type-label {\n  font-size: 9px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.cart-order-type-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a56db;\n  line-height: 1.2;\n}\n\n.cart-order-type-sub {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 1px;\n}\n\n.cart-order-type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #16a34a;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 20px;\n  padding: 4px 10px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cart-order-type-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #16a34a;\n  flex-shrink: 0;\n}\n\n.cartTableInfoContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--surface-white);\n  padding: 8px 10px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  /* margin-bottom: 4px;\n  margin-top: 4px; */\n}\n\n.cartItemDivider {\n  border: none;\n  border-top: 1px dashed #d1d5db;\n  margin: 0 4px;\n}\n\n.cartCouponSectionContainer {\n  background-color: var(--surface-white);\n  padding: 8px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.cartAndSidebarContainer {\n  height: 100%;\n  display: flex;\n  gap: 8px;\n  overflow: hidden;\n  flex: 1;\n  padding: 10px 10px 10px 0px;\n  background: #ffff;\n}\n\n.cartAndSidebarContainer > div:first-child {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cartRightSidebarContainer {\n  flex-shrink: 0;\n  width: 80px;\n  /* Height is dynamically set inline in Cart.js to accommodate table info in Fine Dine */\n  padding-bottom: 8px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.bottomCouponSectionWrapper {\n  margin-bottom: 8px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.toggle-switch {\n  width: 42px;\n  height: 20px;\n  background-color: #ccc;\n  border-radius: 50px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.switch {\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  transition: all 0.3s ease;\n}\n\n.toggle-switch.on .switch {\n  left: 24px;\n}\n\n.toggle-switch.on {\n  background-color: #4caf50;\n}\n\n.listViewActionButton {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.list-view-toggle-container {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-weight: 600;\n  font-size: 0.813rem;\n}\n\n.aggCartProductsLoaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 90%;\n}\n\n.aggCartProductsContainer {\n  /* max-height: 100%; */\n  overflow-y: auto;\n}\n\n.aggCartProductsContainer::-webkit-scrollbar {\n  width: 6px;\n}\n\n.aggCartProductsContainer::-webkit-scrollbar-thumb {\n  background-color: #c1c1c1;\n  border-radius: 3px;\n}\n\n.aggCartProductsContainer::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.aggCartProductsWrapper {\n  margin-bottom: 12px;\n}\n\n.aggCartViewDivider {\n  margin-bottom: 12px;\n  margin-top: 8px;\n  color: var(--surface-g1);\n  opacity: 50%;\n}\n\n.notesInputWithLoader {\n  position: relative;\n  width: 100%;\n}\n\n.loaderInsideNotesInput {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.complimentoryCratWrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.complimentaryModeActionButton {\n  width: 100%;\n  display: flex;\n  gap: 4px;\n}\n\n.mobileFloatingOptsContainer {\n  position: fixed;\n  bottom: 160px;\n  right: 12px;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 1000;\n}\n\n.mobileOptionsBackdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s;\n  z-index: 999;\n}\n\n.mobileOptionsBackdrop.show {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.mobileOptionsSheet {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 60vh;\n  background: #fff;\n  border-radius: 16px 16px 0 0;\n  transform: translateY(100%);\n  transition: transform 0.3s ease;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n}\n\n.mobileOptionsSheet.open {\n  transform: translateY(0);\n}\n\n.sheetHeader {\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px 16px 0px 16px;\n}\n\n.sheetContent {\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.cartBottonOtterWrapper {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.checkoutButton {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.cartInformationText {\n  margin-bottom: 8px;\n  flex-shrink: 0;\n}\n\n.addDeliveryChargeWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.total-text-box {\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.number-icon {\n  margin-left: 4px;\n}\n\n.sub-total-main-wrapper-conatiner-key {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.isExplodingDiv {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.cartBottomSectionContainer {\n  flex-shrink: 0;\n}\n\n.cartGrossActionBarSpacer {\n  height: 35px;\n  flex-shrink: 0;\n}\n\n/* ── Proceed mode layout (DeliveryPage / TakeawayPage / DineinPage) ── */\n\n/* Inner column wrapper: form on top, totals below — stretches to fill the row */\n.cart-proceed-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  gap: 8px;\n}\n\n/* Form takes full width */\n.cart-proceed-content > div {\n  width: 100%;\n}\n\n/* Totals panel: auto height */\n.cart-proceed-content .cartBottonOtterWrapper {\n  height: auto;\n  flex-shrink: 0;\n}\n\n/* No margin-top: auto needed in column layout */\n.cart-proceed-content .cartBottomSectionWrapper.bottom {\n  margin-top: 0;\n}\n\n/* Totals grid: 2 columns side-by-side */\n.cart-proceed-content .cartTotalSection {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 12px;\n  margin-top: 0;\n}\n\n.cart-proceed-content .cartBottomSectionInner {\n  background: var(--surface-white);\n  border-radius: 6px;\n  padding: 6px 8px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8rem;\n}\n\n/* Grand Total spans full width */\n.cart-proceed-content .cartBottomSectionInner:last-child {\n  grid-column: 1 / -1;\n  font-size: 0.875rem;\n  font-weight: 700;\n  background: var(--surface-g0);\n}\n\n/**************** Responsive *****************/\n@media (max-width: 768px) {\n  .cartAndSidebarContainer {\n    height: 100%;\n  }\n\n  .cartProductsList {\n    position: relative;\n  }\n\n  .cartBottomSectionWrapper {\n    margin-bottom: 30px;\n  }\n}\n\n/* ════════════════════════════════════════════════════\n   DARK THEME — Cart\n   ════════════════════════════════════════════════════ */\n.dark .rightContainer {\n  background: #0f172a;\n}\n.dark .cartNewOrderHeader {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n.dark .cartNewOrderLabel,\n.dark .cartNewOrderTime {\n  color: #60a5fa;\n}\n.dark .cartAndSidebarContainer {\n  background: #0f172a;\n}\n.dark .clear-cart-button {\n  background-color: #1e293b;\n  border-color: #475569;\n  color: #60a5fa;\n}\n.dark .customerDetailsContainer {\n  background-color: #1e293b;\n}\n.dark .customerDetailsContainerSecond {\n  border-bottom-color: #334155;\n}\n.dark .cartDetailsCartId {\n  color: #f1f5f9;\n}\n.dark .cartDetailsItemNo {\n  color: #94a3b8;\n}\n.dark .cartTableInfoContainer {\n  background-color: #1e293b;\n}\n.dark .cartCouponSectionContainer {\n  background-color: #1e293b;\n}\n.dark .kotContainer {\n  background-color: #0f172a;\n}\n.dark .kotText {\n  background-color: rgba(42, 113, 255, 0.15);\n  border-color: rgba(42, 113, 255, 0.3);\n}\n.dark .cartItemDivider {\n  border-top-color: #334155;\n}\n/* Empty cart state */\n.dark .empty-cart-state {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .empty-cart-icon-wrap {\n  background: rgba(59, 130, 246, 0.15);\n}\n.dark .empty-cart-title {\n  color: #f1f5f9;\n}\n.dark .empty-cart-sub {\n  color: #94a3b8;\n}\n.dark .emptyCartText {\n  color: #94a3b8;\n}\n.dark .emptyCartSubText {\n  color: #64748b;\n}\n/* Cart order-type card */\n.dark .cart-order-type-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .cart-order-type-label {\n  color: #64748b;\n}\n.dark .cart-order-type-title {\n  color: #60a5fa;\n}\n.dark .cart-order-type-sub {\n  color: #94a3b8;\n}\n/* Cart gross total row */\n.dark .cart-gross-total-label-new {\n  color: #94a3b8;\n}\n.dark .cart-gross-amount-new {\n  color: #f1f5f9;\n}\n/* Cart action buttons */\n.dark .cart-btn-outline {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n  box-shadow: none;\n}\n.dark .cart-btn-outline:hover:not(:disabled) {\n  background-color: #334155;\n  border-color: #475569;\n}\n/* Mobile sheet */\n.dark .mobileOptionsSheet {\n  background: #1e293b;\n}\n/* ── Order Notes Modal ── */\n@keyframes onmSlideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.onm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.onm-modal {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 80vw;\n  background: #fff;\n  border-radius: 0;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.18);\n  animation: onmSlideIn 0.22s ease;\n}\n\n.onm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.onm-title {\n  font-size: 0.9rem;\n  font-weight: 800;\n  color: #d97706;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.onm-optional-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n  background: #f3f4f6;\n  border-radius: 20px;\n  padding: 3px 12px;\n}\n\n.onm-subtitle {\n  font-size: 0.82rem;\n  color: #374151;\n  margin: -6px 0 0 0;\n  line-height: 1.5;\n}\n\n.onm-textarea-wrap {\n  position: relative;\n}\n\n.onm-textarea {\n  width: 100%;\n  border: 1.5px solid #93c5fd;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 0.85rem;\n  color: #111827;\n  resize: none;\n  outline: none;\n  font-family: inherit;\n  line-height: 1.5;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n\n.onm-textarea:focus {\n  border-color: #3b82f6;\n}\n\n.onm-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.onm-loader {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n.onm-char-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 14px;\n  margin-top: -4px;\n}\n\n.onm-char-hint {\n  font-size: 0.78rem;\n  color: #6b7280;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 70%;\n}\n\n.onm-char-count {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n}\n\n.onm-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.onm-btn {\n  height: 38px;\n  padding: 0 22px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.onm-btn-clear {\n  background: #fff;\n  color: #374151;\n  border: 1.5px solid #d1d5db;\n}\n\n.onm-btn-clear:hover {\n  background: #f9fafb;\n}\n\n.onm-btn-done {\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n}\n\n.onm-btn-done:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.onm-btn-done:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* Order notes modal dark */\n.dark .onm-modal {\n  background: #1e293b;\n}\n.dark .onm-title {\n  color: #fbbf24;\n}\n.dark .onm-optional-badge {\n  background: #334155;\n  color: #94a3b8;\n}\n.dark .onm-subtitle {\n  color: #94a3b8;\n}\n.dark .onm-textarea {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .onm-textarea:focus {\n  border-color: #3b82f6;\n}\n.dark .onm-char-row {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .onm-char-hint {\n  color: #64748b;\n}\n.dark .onm-char-count {\n  color: #64748b;\n}\n.dark .onm-btn-clear {\n  background: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n.dark .onm-btn-clear:hover {\n  background: #334155;\n}\n\n@media (min-width: 1024px) and (max-width: 1100px) {\n  .cartGrossAndActionRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 6px;\n    padding: 7px 8px 6px;\n    margin-left: auto;\n  }\n\n  .cartNoteIconBtn {\n    width: 34px;\n    height: 34px;\n    border-radius: 9px;\n  }\n\n  .cartGrossTotalLabel {\n    font-size: 0.62rem;\n    letter-spacing: 0.04em;\n  }\n\n  .cartGrossAmount {\n    font-size: 17px;\n  }\n\n  .cartAndSidebarContainer {\n    gap: 6px;\n    padding: 8px 8px 8px 0;\n  }\n\n  .cartRightSidebarContainer {\n    width: 64px;\n  }\n\n  .qsrSaleModeContainer {\n    padding: 8px 6px;\n  }\n\n  .qsrSaleModeButtons {\n    gap: 3px;\n  }\n}\n\n/* Custom normal buttons styling for cartGrossAndActionRow, matching reference Tailwind design */\n.cart-kitchen-note-btn {\n  display: flex;\n  height: 48px;\n  width: 48px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  border: 1px solid rgba(253, 230, 138, 0.6); /* border-amber-200/60 */\n  background-color: rgba(255, 251, 235, 0.5); /* bg-amber-50/50 */\n  color: #b45309; /* text-amber-700 */\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.08); /* shadow-[0_2px_8px_rgba(245,158,11,0.08)] */\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  outline: none;\n}\n\n.cart-kitchen-note-btn:hover:not(:disabled) {\n  border-color: #fcd34d; /* hover:border-amber-300 */\n  background-color: #fef3c7; /* hover:bg-amber-100 */\n}\n\n.cart-kitchen-note-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cart-kitchen-note-btn svg {\n  width: 20px;\n  height: 20px;\n  stroke-width: 2.5;\n}\n\n.cart-gross-total-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.cart-gross-total-label-new {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #64748b; /* text-slate-500 */\n  margin: 0;\n}\n\n.cart-gross-amount-new {\n  font-size: 1.25rem; /* text-xl */\n  font-weight: 800; /* font-extrabold */\n  color: #0f172a; /* text-slate-900 */\n  line-height: 1; /* leading-none */\n  margin-top: 2px; /* mt-0.5 */\n  margin-bottom: 0;\n}\n\n.cart-btn-outline {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n  border: 1px solid #cbd5e1; /* border-slate-300 */\n  background-color: #ffffff; /* bg-white */\n  padding: 8px 20px;\n  height: 48px;\n  border-radius: 28px;\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  color: #334155; /* text-slate-700 */\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06); /* shadow-[0_8px_20px_rgba(15,23,42,0.06)] */\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.cart-btn-outline:hover:not(:disabled) {\n  border-color: #94a3b8; /* hover:border-slate-400 */\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n}\n\n.cart-btn-outline:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.cart-btn-outline svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.cart-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  outline: none;\n  border: 1px solid #2a71ff;\n  height: 48px;\n  border-radius: 28px;\n  background-color: #2a71ff; /* bg-[#2A71FF] */\n  padding: 8px 32px;\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 700; /* font-bold */\n  color: #ffffff; /* text-white */\n  box-shadow: 0 12px 28px rgba(42, 113, 255, 0.2); /* shadow-[0_12px_28px_rgba(42,113,255,0.2)] */\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.cart-btn-primary:hover:not(:disabled) {\n  background-color: #155eef; /* hover:bg-[#155EEF] */\n  border-color: #155eef;\n  box-shadow: 0 16px 36px rgba(42, 113, 255, 0.25); /* hover:shadow-[0_16px_36px_rgba(42,113,255,0.25)] */\n  transform: translateY(-1px); /* hover:-translate-y-[1px] */\n}\n\n.cart-btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.cart-btn-primary:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.cart-btn-primary svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* ── Cart type strip (B2B / B2C pill) ── */\n.cart-type-strip {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 10px;\n  background: transparent;\n  border-bottom: 1px solid rgba(0,0,0,0.05);\n  flex-shrink: 0;\n}\n.dark .cart-type-strip {\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n.cart-type-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.cart-type-pill--b2b {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n}\n.cart-type-pill--b2c {\n  background: #eff6ff;\n  color: #1e40af;\n  border: 1px solid #bfdbfe;\n}\n.dark .cart-type-pill--b2b {\n  background: rgba(217,119,6,0.15);\n  color: #fcd34d;\n  border-color: rgba(217,119,6,0.3);\n}\n.dark .cart-type-pill--b2c {\n  background: rgba(59,130,246,0.12);\n  color: #93c5fd;\n  border-color: rgba(59,130,246,0.22);\n}\n\n.cart-type-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #92400e;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 160px;\n}\n.dark .cart-type-label { color: #fbbf24; }\n\n/* ── B2B Sales Order badge strip (legacy — kept for non-item sections) ── */\n.b2b-order-badge-strip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #fffbeb, #fef3c7);\n  border-bottom: 1px solid #fde68a;\n  flex-shrink: 0;\n}\n.b2b-order-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 9px;\n  border-radius: 9999px;\n  background: #d97706;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n.b2b-order-badge svg { flex-shrink: 0; }\n.b2b-order-partner {\n  font-size: 12px;\n  font-weight: 500;\n  color: #92400e;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dark .b2b-order-badge-strip {\n  background: linear-gradient(135deg, #1c1107, #27180a);\n  border-bottom-color: #78350f;\n}\n.dark .b2b-order-badge { background: #b45309; }\n.dark .b2b-order-partner { color: #fbbf24; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
